import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "searchPipe",
})
export class SearchPipePipe implements PipeTransform {
  transform(items: any[], terms: string): any[] {
    if (!items) return [];
    if (!terms) return items;
    terms = terms.toLowerCase();
    return items.filter((it) => {
      return it.displayValue.toLowerCase().indexOf(terms.toLowerCase()) > -1;
    });
  }
}
